import { Link } from 'react-router-dom';
import PolicyLayout from './PolicyLayout';
import { POLICY_UPDATED, SALES_EMAIL } from '../constants/site';

export default function ReturnPolicy() {
  return (
    <PolicyLayout
      title="Return Policy"
      updated={POLICY_UPDATED}
      intro="Software licences behave differently from physical goods. This page explains what can be returned and when."
    >
      <h2>Unredeemed licences</h2>
      <p>
        If a product key has not been redeemed, you may return the licence within 30 days of
        purchase for a full refund. Email us the order number and confirm that the key has not
        been activated.
      </p>

      <h2>Redeemed licences</h2>
      <p>
        Once a key has been activated against a publisher account, the return is handled under
        the publisher&apos;s money-back guarantee rather than by us. We will prepare the
        request and submit it on your behalf at no charge.
      </p>

      <h2>Subscription products</h2>
      <p>
        Annual subscriptions can be cancelled within 30 days of the start of a term.
        Cancellation stops the next renewal; the current term continues until its end date
        unless the publisher approves a mid-term refund.
      </p>

      <h2>Services</h2>
      <p>
        Diagnostic and repair work is a service rather than a returnable good. Where the work
        did not achieve what the quote described, our{' '}
        <Link to="/refund-policy">refund policy</Link> applies instead.
      </p>

      <h2>How to start a return</h2>
      <p>
        Email <a href={`mailto:${SALES_EMAIL}`}>{SALES_EMAIL}</a> with your order number and
        the reason for the return. We confirm receipt the same working day and tell you the
        next step within two working days.
      </p>
    </PolicyLayout>
  );
}
